import { useEffect } from "react";
import { Navigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { authSliceActions, selectAuth } from "store/authSlice";
import useLogin from "hooks/uselogin";
import LoadingSpinner from "components/Ui/LoadingSpinner/LoadingSpinner";
import PageErrorFallback from "components/Ui/ErrorBoundary/PageErrorFallback";
import { requestForToken } from "../../../firbase";
import { getStoredToken } from "utils/auth";

const ProtectedRoute = ({ condition = true, children }) => {
    const dispatch = useDispatch();
    const { isAuthenticated, hasHydrated } = useSelector(selectAuth);
    const adminInfo = useSelector((state) => state.auth.userData);
    const { getProfileBytoken, loading, error } = useLogin();

    useEffect(() => {
        if (hasHydrated) {
            return;
        }

        if (!getStoredToken()) {
            dispatch(authSliceActions.logout());
            return;
        }

        getProfileBytoken();
    }, [dispatch, getProfileBytoken, hasHydrated]);

    useEffect(() => {
        if (hasHydrated && isAuthenticated) {
            requestForToken();
        }
    }, [hasHydrated, isAuthenticated]);

    if (!hasHydrated && error && !loading) {
        return (
            <PageErrorFallback
                isFullScreen
                title="تعذر تحميل الحساب"
                message="تعذر الاتصال بالخادم. بقي تسجيل دخولك محفوظاً ويمكنك المحاولة مرة أخرى."
                onRetry={getProfileBytoken}
            />
        );
    }

    if (!hasHydrated || loading) {
        return <LoadingSpinner />;
    }

    if (!isAuthenticated || !adminInfo?.id) {
        return <Navigate to="/login" replace />;
    }

    if (!condition) {
        return <Navigate to="/" replace />;
    }

    return children;
};

export default ProtectedRoute;
